// extracted by mini-css-extract-plugin
export default {"wrapper":"NTMv1bUMpBhs0m6CkAIJ"};